import type { FaireProductEntity } from "../../entity_types/product";

export const p_gq5zuzvf38: FaireProductEntity = {
  token: "p_gq5zuzvf38",
  type: "product",
  name: "12 Color Selection 100% Wool Knitted Triangle Scarf for Women",
  brandToken: "b_5qb9p6vh8d",
  brandName: "SALINA TRADING INC",
  imageUrl:
    "https://cdn.faire.com/fastly/038c802273d6bc5173c5654629e06711d98b6b13ea1f008dbc6a6be5df144c41.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ce78d8991463d26d6874f2aba9a8dc0c5bfe8e0d4ed1536015fb7a372d86d04.jpeg",
    "https://cdn.faire.com/fastly/84c2c2a25979732253dddcc905a7d07d7c31ec5b0b7214f09e0095bf2dccae9b.jpeg",
    "https://cdn.faire.com/fastly/ff2ad612895eda3d9778cf3c76ac5d375bb8e62d82f2d744a0b655156a00e4b8.jpeg",
    "https://cdn.faire.com/fastly/f0e6ba1e766440c7b0606b74f8d23b3789d5490ccab17f18e068f43244580b25.jpeg",
    "https://cdn.faire.com/fastly/7452ed4cfef9761916ac920c85d043d06652ab5dc641771816d26213a8ffdab2.jpeg",
    "https://cdn.faire.com/fastly/9305ba8f9552a8d02f05a053eacb5cc99641aa8e3c1811193007a0af81d7ee7e.jpeg",
    "https://cdn.faire.com/fastly/084a11ddf52fa33f979bcfafa668f53bcaa8fc42cf87456037a9cae71ccac967.jpeg",
    "https://cdn.faire.com/fastly/cde81cef9cef9adb3792e96ab746f88c92e4c5cbbb33a4725d47c0f3292ee001.jpeg",
    "https://cdn.faire.com/fastly/c367f0fcfb859027e6852b095575e31e08926be8830811b38be8531b469b1433.jpeg",
    "https://cdn.faire.com/fastly/77d5b4b55b2bb9e5ffa51884e61f0040dbc5524d109ae40dad0f429163551fcc.jpeg",
    "https://cdn.faire.com/fastly/42cd8301a7c0571f4b3f24b7c06461ec31c530d18828999654d0f28ff6584079.jpeg",
    "https://cdn.faire.com/fastly/0891b1c1c63a1a6b3f2406cca3f2ce4c78005d23f7540465c9caa56bdf97e2d2.jpeg",
    "https://cdn.faire.com/fastly/e413275c94ef3684d8ecb5b5fdc4633c7c9c35046c2b4eb6a74b43c9444756a6.jpeg",
    "https://cdn.faire.com/fastly/b2fc39496fe2772c94138073f6cb175a388108a018e8506a16cdac371cfa9acb.jpeg",
    "https://cdn.faire.com/fastly/0c49252623ed8ddc95201c4654cd4ddf91c5633044421f457a029e2cd321bee0.jpeg",
  ],
  priceDollars: 10.75,
  description:
    "Material: Made from 100% high-quality wool, this knitted triangular scarf provides excellent warmth and comfort for your neck during cold months.\n\nSize: Measures 110 cm x 37 cm, perfect for wrapping around your neck or draping over your shoulders as a stylish shawl.\n\nStyle: Featuring a unique geometric design, this scarf reflects a blend of contemporary and street styles, making it suitable for various occasions.\n\nCare Instructions: Hand wash or dry clean only to preserve the quality and softness of the wool fabric.\n\nThis versatile scarf is not only fashionable but also functional, making it an essential accessory for your fall and winter wardrobe. Its diverse color options ensure you can match it with any outfit, adding a pop of color while keeping warm.\n",
  tags: [],
  msrpDollars: 21.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:37.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
